import { useNavigate } from "react-router-dom";

import { ROUTES } from "../../../../constants/routes";
import SavedIcon from "../../../../components/icons/searchIcons/savedIcon";
import styles from "./ActorCard.module.scss";
import {useTranslation} from "react-i18next";

type Props = {
  actorId: number | undefined
  fullName: string
  description: string
  image: string
  isFav?: boolean
  onFavouriteClick?: (e: React.MouseEvent, actorId: number, isFav: boolean) => void
}

const ActorCard = ({ actorId, fullName, description, image, isFav = false, onFavouriteClick }: Props) => {
  const navigate = useNavigate();
  const { i18n } = useTranslation();

  const clickHandler = () => {
    if (actorId) navigate(`${ROUTES.ACTORS}/${actorId}`);
  };

  const dirData = i18n.language === "ar" ? "rtl" : "ltr";

  return (
    <div dir={dirData} className={styles.wrapper} onClick={clickHandler} style={actorId ? undefined : { cursor: "default" }}>
      <img
        width={130}
        height={130}
        className={styles.image}
        src={image ? image : ""}
        alt="#"
      />
      <div className={styles.textWrapper}>
          <h3 className={styles.fullName}>{fullName}</h3>
        <p className={styles.description}>{description}</p>
        {actorId && onFavouriteClick && (
          <button
            className={styles.savedBtn}
            type="button"
            aria-label="toggle actor favorite"
            onClick={(e) => {
              e.stopPropagation();
              onFavouriteClick(e, actorId, isFav);
            }}
          >
            <SavedIcon className={styles.savedIcon} inFavourites={isFav} />
          </button>
        )}
      </div>
    </div>
  )
}

export default ActorCard
